import UILabels from "utils/types/UILabels";
import maxAllowedCharsForFolderName from "./maxAllowedCharsForFolderName";

const labels: UILabels = {
  en: {
    overdue: "Overdue",
    dueDate: "Due Date",
    selectMultipleTodos: "Select Multiple Todos",
    mouseClick: "Mouse Click",
    sidebarNavigation: "Sidebar Navigation",
    arrowLeftSymbol: "←",
    arrowRightSymbol: "→",
    alt: "Alt",
    oneSymbol: "1",
    nineSymbol: "9",
    arrowDownSymbol: "↓",
    arrowUpSymbol: "↑",
    none: "None",
    minute: "Minute",
    automaticLockTime: "Automatic Lock Time",
    automaticallyLockScreenAfter:
      "Automatically lock the screen after the specified time",
    loading: "Loading",
    loadingTasks: "Loading Your Tasks",
    itemsHasMovedTo: "items have been moved to",
    allowDrafts: "Allow Drafts",
    allowDraftsDescription:
      "Do not save any drafts when creating todos/folders form",
    activate: "Activate",
    noSearchResults: "No Search Results",
    tryDifferentKeywords: "Try different Keywords",
    filterTodosDots: "Filter Todos...",
    selectFolderDots: "Select a Folder...",
    resetPreferences: "Reset Preferences",
    areYouSureRemoveItems:
      "Are you sure you want to remove all the following items?",
    checkItemsEnableOk: "Check all items to enable /Ok/ button...",
    causeReload: "This will cause a page reload",
    language: "Language",
    languages: "Languages",
    removeFolder: "Remove Folder",
    createFolder: "Create Folder",
    sureRemoveFolder:
      "Are you sure you want to remove this folder? This will affect the related todos.",
    remove: "Remove",
    edit: "Edit",
    finish: "Finish",
    restore: "Restore",
    addEditFolder: "Add / Edit Folder",
    total: "Total",
    removeFinished: "Remove Finished",
    select: "Select",
    selected: "Selected",
    finished: "Finished",
    all: "All",
    trash: "Trash",
    active: "Active",
    filterTodos: "Filter Todos...",
    createTodo: "Create Todo",
    removeAll: "Remove All",
    results: "Results",
    create: "Create",
    cancel: "Cancel",
    activateAll: "Activate All",
    clearAll: "Clear All",
    finishAll: "Finish All",
    sureClearAllItems: "Are you sure you want to clear all items?",
    allTodos: "All Todos",
    activeTodos: "Active Todos",
    finishedTodos: "Finished Todos",
    folders: "Folders",
    noFolders: "No Folders!",
    title: "Title",
    description: "Description",
    priority: "Priority",
    icon: "Icon",
    maxAllowedChars200: `Max allowed characters is ${maxAllowedCharsForFolderName}`,
    close: "Close",
    hide: "Hide",
    show: "Show",
    sidebar: "Sidebar",
    ok: "Ok",
    nothingToShow: "Nothing to Show!",
    clickOnButtonToCreateTodo:
      "Click on (+) button in the bottom-right corner to create new todo.",
    low: "Low",
    high: "High",
    medium: "Medium",
    mobileNotSupported: "Mobile Not Supported",
    cleanTodoNotSupported:
      "Unfortunately, Clean Todo is not supported for mobile devices",
    notSupportedYet: "Not Supported Yet!",
    preferences: "Preferences",
    todo: "Todo",
    background: "Background",
    theme: "Theme",
    filter: "Filter",
    shortcuts: "Shortcuts",
    shortcut: "Shortcut",
    editOnDoubleClick: "Edit on Double Click",
    editOnDoubleClickDescription:
      "By enabling this option, the edit dialogue opened when you double click on todo's text",
    alwaysShowDescription: "Always Show Description",
    alwaysShowDescriptionDescription:
      "Show the description text on the todo's body",
    alwaysShowPriorityIcon: "Always Show Priority Icon",
    alwaysShowPriorityIconDescription:
      "Show the priority icon on the todo's body",
    collapseDescription: "Collapse Description",
    collapseDescriptionDescription:
      "By enabling this option, the collapse/expand feature will not present. The description will be always expanded without the ability to collapsing it",
    includeDescription: "Include Description",
    includeDescriptionDescription:
      "Include todo's description in filtering results",
    includeFolder: "Include Folder",
    includeFolderDescription:
      "Include todo's folder title in filtering results",
    includeDate: "Include Date",
    includeDateDescription: "Include todo's date in filtering results",
    other: "Other",
    resetToDefault: "Reset Preferences to Default",
    clickToConfirm: "Click to Confirm",
    createNewTodo: "Create new todo",
    createNewFolder: "Create new folder",
    exitSelectMode: "Exit select mode / close dialogues",
    esc: "Esc",
    ctrl: "Ctrl",
    shift: "Shift",
    q: "Q",
    a: "A",
    b: "B",
    l: "L",
    p: "P",
    plusSign: "+",
    selectAllTodos: "Select all todos",
    importJsonFile:
      "Import a json file to be loaded into clean-todo application and get all your todos, folders and preferences. ** All the old data will be replaced with the new one **",
    import: "Import",
    importData: "Import Data",
    export: "Export",
    cantImport: "Can't import, the selected json is not a valid one",
    passCode: "Pass Code",
    passCodeCheck: "Pass Code Check",
    enterPassCode4: "Enter the 4 characters pass code",
    check: "Check",
    disablePassCodeLose: "Disable Pass Code",
    loseAllData: "You will lose all of your data if you click this button",
    lockScreen: "Lock Screen",
    privacy: "Privacy",
    setPassCode: "Set Pass Code",
    enterPassCode: "Enter Pass Code",
    reenter: "Re-enter",
    cantEmptyNotMatch:
      "Fields can't be empty / the two entered pass codes doesn't match / the pass code must be 4 characters",
    disablePassCode: "Disable Pass Code",
    cantEmpty4: "The pass code can't be empty and must be 4 characters",
    invalidPassCode: "Invalid pass code",
    openPreferences: "Open Preferences",
    toCreateNewFolders:
      "To create new folder, go to Sidebar, Folders, then click on /Create Folder/ button",
    folder: "Folder",
  },
  "zh-CN": {
    overdue: "过期",
    dueDate: "截止日期",
    selectMultipleTodos: "选择多个待办事项",
    mouseClick: "鼠标点击",
    sidebarNavigation: "侧边栏导航",
    arrowLeftSymbol: "←",
    arrowRightSymbol: "→",
    alt: "Alt",
    oneSymbol: "1",
    nineSymbol: "9",
    arrowDownSymbol: "↓",
    arrowUpSymbol: "↑",
    none: "无",
    minute: "分钟",
    automaticLockTime: "自动锁定时间",
    automaticallyLockScreenAfter: "指定时间后自动锁屏",
    loading: "加载中",
    loadingTasks: "正在加载您的任务",
    itemsHasMovedTo: "件商品已移至",
    allowDrafts: "允许草稿",
    allowDraftsDescription: "创建待办事项/文件夹表单时不要保存任何草稿",
    activate: "启用",
    noSearchResults: "没有搜索结果",
    tryDifferentKeywords: "尝试不同的关键词",
    filterTodosDots: "过滤任务...",
    selectFolderDots: "选择一个文件夹...",
    resetPreferences: "重置偏好设置",
    areYouSureRemoveItems: "您确定要删除以下所有项目吗?",
    checkItemsEnableOk: "检查所有项目以启用/确定/按钮...",
    causeReload: "这将导致页面重新加载",
    language: "语言",
    languages: "语言",
    removeFolder: "删除文件夹",
    createFolder: "创建文件夹",
    sureRemoveFolder: "您确定要删除该文件夹吗？ 这将影响相关的待办事项。",
    remove: "消除",
    edit: "编辑",
    finish: "结束",
    restore: "恢复",
    addEditFolder: "添加 / 编辑文件夹",
    total: "全部的",
    removeFinished: "删除完成",
    select: "选择",
    selected: "已选择",
    finished: "完成的",
    all: "全部",
    trash: "垃圾",
    active: "积极的",
    filterTodos: "过滤待办事项...",
    createTodo: "创建待办事项",
    removeAll: "移除所有",
    results: "结果",
    create: "创造",
    cancel: "取消",
    activateAll: "全部激活",
    clearAll: "全部清除",
    finishAll: "完成全部",
    sureClearAllItems: "您确定要清除所有项目吗?",
    allTodos: "所有待办事项",
    activeTodos: "活跃待办事项",
    finishedTodos: "活跃待办事项",
    folders: "文件夹",
    noFolders: "没有分类!",
    title: "标题",
    description: "描述",
    priority: "优先事项",
    icon: "图标",
    maxAllowedChars200: `允许的最大字符数为 ${maxAllowedCharsForFolderName}`,
    close: "关闭",
    hide: "隐藏",
    show: "展示",
    sidebar: "侧边栏",
    ok: "好的",
    nothingToShow: "没有什么可显示的!",
    clickOnButtonToCreateTodo: "单击右下角的 (+) 按钮创建新待办事项。",
    low: "低的",
    high: "高的",
    medium: "中等的",
    mobileNotSupported: "不支持移动设备",
    cleanTodoNotSupported: "不幸的是，移动设备不支持 Clean Todo",
    notSupportedYet: "尚不支持!",
    preferences: "优先",
    todo: "去做",
    background: "背景",
    theme: "主题",
    filter: "筛选",
    shortcuts: "快捷方式",
    shortcut: "捷径",
    editOnDoubleClick: "双击编辑",
    editOnDoubleClickDescription:
      "通过启用此选项，当您双击待办事项的文本时会打开编辑对话框",
    alwaysShowDescription: "始终显示说明",
    alwaysShowDescriptionDescription: "在待办事项正文上显示描述文本",
    alwaysShowPriorityIcon: "始终显示优先图标",
    alwaysShowPriorityIconDescription: "在待办事项主体上显示优先级图标",
    collapseDescription: "折叠说明",
    collapseDescriptionDescription:
      "通过启用此选项，折叠/展开功能将不会出现。 描述将始终展开而无法折叠",
    includeDescription: "包括说明",
    includeDescriptionDescription: "在过滤结果中包含待办事项的描述",
    includeFolder: "包含文件夹",
    includeFolderDescription: "在过滤结果中包含待办事项的文件夹标题",
    includeDate: "包含日期",
    includeDateDescription: "在过滤结果中包含待办事项的日期",
    other: "其他",
    resetToDefault: "将首选项重置为默认值",
    clickToConfirm: "点击确认",
    createNewTodo: "创建新待办事项",
    createNewFolder: "创建新文件夹",
    exitSelectMode: "退出选择模式 / 关闭对话框",
    esc: "Esc",
    ctrl: "Ctrl",
    shift: "Shift",
    q: "Q",
    a: "A",
    b: "B",
    l: "L",
    p: "P",
    plusSign: "+",
    selectAllTodos: "选择所有待办事项",
    importJsonFile:
      "导入要加载到 clean-todo 应用程序中的 json 文件并获取所有待办事项、文件夹和首选项。 ** 所有旧数据将替换为新数据 **",
    import: "进口",
    importData: "导入数据",
    export: "出口",
    cantImport: "无法导入，所选的 json 无效",
    passCode: "密码",
    passCodeCheck: "密码检查",
    enterPassCode4: "输入 4 个字符的密码",
    check: "查看",
    disablePassCodeLose: "禁用密码",
    loseAllData: "如果单击此按钮，您将丢失所有数据",
    lockScreen: "锁屏",
    privacy: "隐私",
    setPassCode: "设置密码",
    enterPassCode: "输入密码",
    reenter: "重新输入",
    cantEmptyNotMatch: "字段不能为空/输入的两个密码不匹配/密码必须为 4 个字符",
    disablePassCode: "禁用密码",
    cantEmpty4: "密码不能为空且必须为 4 个字符",
    invalidPassCode: "密码无效",
    openPreferences: "打开偏好设置",
    toCreateNewFolders:
      "要创建新文件夹，请转到侧栏、文件夹，然后单击/创建文件夹/按钮",
    folder: "文件夹",
  },
  fr: {
    overdue: "En Retard",
    dueDate: "Date D'échéance",
    selectMultipleTodos: "Sélectionnez Plusieurs Tâches",
    mouseClick: "Clic Souris",
    sidebarNavigation: "Navigation Barre Latérale",
    arrowLeftSymbol: "←",
    arrowRightSymbol: "→",
    alt: "Alt",
    oneSymbol: "1",
    nineSymbol: "9",
    arrowDownSymbol: "↓",
    arrowUpSymbol: "↑",
    none: "Aucune",
    minute: "Minute",
    automaticLockTime: "Temps Verrouillage Automatique",
    automaticallyLockScreenAfter:
      "Verrouiller automatiquement l'écran après l'heure spécifiée",
    loading: "Chargement",
    loadingTasks: "Chargement des tâches",
    itemsHasMovedTo: "éléments ont été déplacés vers",
    allowDrafts: "Autoriser Brouillons",
    allowDraftsDescription:
      "Ne pas enregistrer de brouillons lors de la création d'un formulaire de tâches/dossiers",
    activate: "Activer",
    noSearchResults: "Aucun Résultat Trouvé",
    tryDifferentKeywords: "Essayez différents mots clés.",
    filterTodosDots: "Filtrer Tâches...",
    selectFolderDots: "Choisir une Dossier...",
    resetPreferences: "Remettre à Zéro Préférences",
    areYouSureRemoveItems:
      "Êtes-vous sûr de vouloir supprimer tous les éléments suivants?",
    checkItemsEnableOk:
      "Vérifiez tous les éléments pour activer le bouton /Ok/...",
    causeReload: "Cela entraînera un rechargement de la page",
    language: "Langue",
    languages: "Langages",
    removeFolder: "Supprimer Dossier",
    createFolder: "Créer Une Dossier",
    sureRemoveFolder:
      "Êtes-vous sûr de vouloir supprimer cette dossier ? Cela affectera les tâches associées.",
    remove: "Retirer",
    edit: "Modifier",
    finish: "Finition",
    restore: "Restaurer",
    addEditFolder: "Ajouter / Modifier dossier",
    total: "Total",
    removeFinished: "Supprimer Terminé",
    select: "Sélectionner",
    selected: "Sélectionnée",
    finished: "Terminé",
    all: "Tout",
    trash: "Poubelle",
    active: "Actif",
    filterTodos: "Filtrer Tâches...",
    createTodo: "Créer Tâche",
    removeAll: "Enlever Tout",
    results: "Résultats",
    create: "Créer",
    cancel: "Annuler",
    activateAll: "Activer Tout",
    clearAll: "Tout Effacer",
    finishAll: "Terminer Tout",
    sureClearAllItems: "Êtes-vous sûr de vouloir effacer tous les éléments ?",
    allTodos: "Toutes Tâches",
    activeTodos: "Tâches Actives",
    finishedTodos: "Tâches Terminées",
    folders: "Dossiers",
    noFolders: "Aucune Dossier!",
    title: "Titre",
    description: "Description",
    priority: "Priorité",
    icon: "icône",
    maxAllowedChars200: `Le nombre maximum de caractères autorisés est de ${maxAllowedCharsForFolderName}`,
    close: "Fermer",
    hide: "Cacher",
    show: "Montrer",
    sidebar: "Barre latérale",
    ok: "D'accord",
    nothingToShow: "Rien à montrer!",
    clickOnButtonToCreateTodo:
      "Cliquez sur le bouton (+) dans le coin inférieur droit pour créer une nouvelle tâche.",
    low: "Faible",
    high: "Haut",
    medium: "Moyen",
    mobileNotSupported: "Mobile non pris en charge",
    cleanTodoNotSupported:
      "Malheureusement, Clean Todo n'est pas pris en charge pour les appareils mobiles",
    notSupportedYet: "Pas encore pris en charge!",
    preferences: "Préférences",
    todo: "Tâche",
    background: "Arrière-plan",
    theme: "Thème",
    filter: "Filtre",
    shortcuts: "Raccourcis",
    shortcut: "Raccourci",
    editOnDoubleClick: "Modifier Par Double-clic",
    editOnDoubleClickDescription:
      "En activant cette option, la boîte de dialogue d'édition s'ouvre lorsque vous double-cliquez sur le texte de la tâche",
    alwaysShowDescription: "Toujours Afficher Description",
    alwaysShowDescriptionDescription:
      "Afficher le texte de description sur le corps de la tâche",
    alwaysShowPriorityIcon: "Toujours Afficher L'icône de Priorité",
    alwaysShowPriorityIconDescription:
      "Afficher l'icône de priorité sur le corps de la tâche",
    collapseDescription: "Réduire Description",
    collapseDescriptionDescription:
      "En activant cette option, la fonctionnalité réduire/développer ne sera pas présente. La description sera toujours développée sans possibilité de la réduire",
    includeDescription: "Inclure Description",
    includeDescriptionDescription:
      "Inclure la description de la tâche dans les résultats de filtrage",
    includeFolder: "Inclure Dossier",
    includeFolderDescription:
      "Inclure le titre de la dossier de la tâche dans les résultats de filtrage",
    includeDate: "Inclure Date",
    includeDateDescription:
      "Inclure la date de la tâche dans les résultats de filtrage",
    other: "Autre",
    resetToDefault: "Réinitialiser Préférences par Défaut",
    clickToConfirm: "Cliquez pour confirmer",
    createNewTodo: "Créer une nouvelle tâche",
    createNewFolder: "Créer une nouvelle dossier",
    exitSelectMode: "Quitter Mode de Sélection / Fermer Dialogues",
    esc: "Esc",
    ctrl: "Ctrl",
    shift: "Shift",
    q: "Q",
    a: "A",
    b: "B",
    l: "L",
    p: "P",
    plusSign: "+",
    selectAllTodos: "Sélectionnez Toutes Tâches",
    importJsonFile:
      "Importez un fichier json à charger dans l'application clean-todo et obtenez toutes vos tâches, dossiers et préférences. ** Toutes les anciennes données seront remplacées par les nouvelles **",
    import: "Importer",
    importData: "Importer Données",
    export: "Exporter",
    cantImport: "Impossible d'importer, le json sélectionné n'est pas valide",
    passCode: "Code d'accès",
    passCodeCheck: "Vérification du Code D'accès",
    enterPassCode4: "Entrez le code d'accès à 4 caractères",
    check: "Vérifier",
    disablePassCodeLose: "Désactiver Code D'accès",
    loseAllData:
      "Vous perdrez toutes vos données si vous cliquez sur ce bouton",
    lockScreen: "Écran Verrouillé",
    privacy: "Confidentialité",
    setPassCode: "Définir Code D'accès",
    enterPassCode: "Entrer Mot de Passe",
    reenter: "Entrez à Nouveau",
    cantEmptyNotMatch:
      "Les champs ne peuvent pas être vides / les deux codes d'accès saisis ne correspondent pas / le code d'accès doit comporter 4 caractères",
    disablePassCode: "Désactiver Code D'accès",
    cantEmpty4:
      "Le code d'accès ne peut pas être vide et doit comporter 4 caractères",
    invalidPassCode: "Code d'accès invalide",
    openPreferences: "Ouvrir Préférences",
    toCreateNewFolders:
      "Pour créer une nouvelle dossier, allez dans la barre latérale, Dossiers, puis cliquez sur le bouton /Créer Dossier/",
    folder: "Dossier",
  },
  es: {
    overdue: "Atrasada",
    dueDate: "Fecha Vencimiento",
    selectMultipleTodos: "Seleccionar Múltiples Todos",
    mouseClick: "Click Raton",
    sidebarNavigation: "Navegación Barra Lateral",
    arrowLeftSymbol: "←",
    arrowRightSymbol: "→",
    alt: "Alt",
    oneSymbol: "1",
    nineSymbol: "9",
    arrowDownSymbol: "↓",
    arrowUpSymbol: "↑",
    none: "Ninguna",
    minute: "Minuto",
    automaticLockTime: "Tiempo Bloqueo Automático",
    automaticallyLockScreenAfter:
      "Bloquear automáticamente la pantalla después del tiempo especificado",
    loading: "Cargando",
    loadingTasks: "Cargando Tus Tareas",
    itemsHasMovedTo: "artículos han sido movidos a",
    allowDrafts: "Permitir Borradores",
    allowDraftsDescription:
      "No guarde ningún borrador al crear el formulario de todos/carpetas",
    activate: "Activar",
    noSearchResults: "No Hay Resultados de Búsqueda",
    tryDifferentKeywords: "Pruebe diferentes palabras clave.",
    filterTodosDots: "Filtrar Tareas...",
    selectFolderDots: "Seleccione una Carpeta...",
    resetPreferences: "Reiniciar Preferencias",
    areYouSureRemoveItems:
      "Está seguro de que desea eliminar todos los elementos siguientes?",
    checkItemsEnableOk:
      "Marque todos los elementos para habilitar el botón /Aceptar/...",
    causeReload: "Esto provocará que la página se recargue.",
    language: "Idioma",
    languages: "Idiomas",
    removeFolder: "Eliminar Carpeta",
    createFolder: "Crear Carpeta",
    sureRemoveFolder:
      "Estás seguro de que deseas eliminar esta carpeta? Esto afectará a todos los relacionados.",
    remove: "Eliminar",
    edit: "Editar",
    finish: "Finalizar",
    restore: "Restaurar",
    addEditFolder: "Agregar / Editar carpeta",
    total: "Total",
    removeFinished: "Eliminar terminada",
    select: "Seleccionar",
    selected: "Seleccionada",
    finished: "Finalizada",
    all: "Toda",
    trash: "Basura",
    active: "Activa",
    filterTodos: "Filtrar tareas...",
    createTodo: "Crear Tarea",
    removeAll: "Eliminar Tarea",
    results: "Resultados",
    create: "Crear",
    cancel: "Cancelar",
    activateAll: "Activar Todo",
    clearAll: "Limpiar Todo",
    finishAll: "Terminar Todo",
    sureClearAllItems:
      "Estás segura de que quieres borrar todos los artículos?",
    allTodos: "Todas Tareas",
    activeTodos: "Tareas activas",
    finishedTodos: "Tareas Terminadas",
    folders: "Carpetas",
    noFolders: "Sin Carpetas!",
    title: "Título",
    description: "Descripción",
    priority: "Prioridad",
    icon: "Icono",
    maxAllowedChars200: `El máximo de caracteres permitidos es ${maxAllowedCharsForFolderName}.`,
    close: "Cerca",
    hide: "Hide",
    show: "Esconder",
    sidebar: "Barra Lateral",
    ok: "De acuerdo",
    nothingToShow: "Nada que Mostrar!",
    clickOnButtonToCreateTodo:
      "Haga clic en el botón (+) en la esquina inferior derecha para crear una nueva tarea pendiente",
    low: "Baja",
    high: "Alta",
    medium: "Medio",
    mobileNotSupported: "Móvil no Compatible",
    cleanTodoNotSupported:
      "Lamentablemente, Clean Todo no es compatible con dispositivos móviles",
    notSupportedYet: "Aún no es compatible!",
    preferences: "Preferences",
    todo: "Hacer",
    background: "Fondo",
    theme: "Tema",
    filter: "Filtrar",
    shortcuts: "Atajos",
    shortcut: "Atajo",
    editOnDoubleClick: "Editar con Doble Clic",
    editOnDoubleClickDescription:
      "Al habilitar esta opción, el diálogo de edición se abre al hacer doble clic en el texto de todo",
    alwaysShowDescription: "Mostrar Siempre Descripción",
    alwaysShowDescriptionDescription:
      "Mostrar el texto de descripción en el cuerpo de la tarea",
    alwaysShowPriorityIcon: "Mostrar Siempre el Icono de Prioridad",
    alwaysShowPriorityIconDescription:
      "Mostrar el ícono de prioridad en el cuerpo de la tarea",
    collapseDescription: "Contraer Descripción",
    collapseDescriptionDescription:
      "Al habilitar esta opción, la función contraer/expandir no estará presente. La descripción siempre se expandirá sin posibilidad de contraerla",
    includeDescription: "Incluye Descripción",
    includeDescriptionDescription:
      "Incluir la descripción de todo en el filtrado de resultados",
    includeFolder: "Incluir Carpeta",
    includeFolderDescription:
      "Incluir el título de la carpeta de tareas pendientes en el filtrado de resultados",
    includeDate: "Incluir Fecha",
    includeDateDescription:
      "Incluir la fecha de todo en el filtrado de resultados",
    other: "Otra",
    resetToDefault: "Restablecer Preferencias a las Predeterminadas",
    clickToConfirm: "Haga Clic Para Confirmar",
    createNewTodo: "Crear nueva tarea",
    createNewFolder: "Crear nueva carpeta",
    exitSelectMode: "Salir del modo de selección / cerrar diálogos",
    esc: "Esc",
    ctrl: "Ctrl",
    shift: "Shift",
    q: "Q",
    a: "A",
    b: "B",
    l: "L",
    p: "P",
    plusSign: "+",
    selectAllTodos: "Seleccionar Todas Tareas",
    importJsonFile:
      "Importe un archivo json para cargarlo en la aplicación clean-todo y obtenga todos sus todos, carpetas y preferencias. ** Todos los datos antiguos serán reemplazados por los nuevos **",
    import: "Importar",
    importData: "Datos Importacion",
    export: "Exportar",
    cantImport: "No se puede importar, el json seleccionado no es válido",
    passCode: "Código Acceso",
    passCodeCheck: "Verificación de Código Acceso",
    enterPassCode4: "Ingrese el código de acceso de 4 caracteres",
    check: "Controlar",
    disablePassCodeLose: "Desactivar Código Acceso",
    loseAllData: "Perderás todos tus datos si haces clic en este botón",
    lockScreen: "Bloquear Pantalla",
    privacy: "Privacidad",
    setPassCode: "Código Acceso Establecido",
    enterPassCode: "Introduce un Código Acceso",
    reenter: "Volver a entrar en",
    cantEmptyNotMatch:
      "Los campos no pueden estar vacíos/los dos códigos de acceso ingresados no coinciden/el código de acceso debe tener 4 caracteres",
    disablePassCode: "Desactivar Código Acceso",
    cantEmpty4:
      "El código de acceso no puede estar vacío y debe tener 4 caracteres",
    invalidPassCode: "Código de acceso no válido",
    openPreferences: "Abrir Preferencias",
    toCreateNewFolders:
      "Para crear una nueva carpeta, vaya a la barra lateral, Carpetas, luego haga clic en el botón /Crear carpeta/",
    folder: "Carpeta",
  },
};

export default labels;
